// extracted by mini-css-extract-plugin
module.exports = {"required":"FormYesNo_required_3pOU2","error":"FormYesNo_error_3My9a","radioBox":"FormYesNo_radioBox_2LyiE","label":"FormYesNo_label_1ayeH"};